import { Gavel, FileText, Building2, FileSearch, BookOpen } from "lucide-react";
import { ParallaxText, ScrollFadeIn } from "@/components/Parallax";

const SERVICIOS_COMP = [
  {
    id: "representacion",
    icon: Gavel,
    title: "Representación judicial civil y comercial"
  },
  {
    id: "contratos",
    icon: FileText,
    title: "Revisión y redacción de contratos"
  },
  {
    id: "sociedades",
    icon: Building2,
    title: "Constitución y modificación de sociedades"
  },
  {
    id: "poderes",
    icon: FileSearch,
    title: "Informes de poderes y antecedentes societarios"
  },
  {
    id: "titulos",
    icon: BookOpen,
    title: "Estudios de títulos"
  }
];

export default function ServiciosComplementariosSection() {
  return (
    <section id="servicios-complementarios" data-testid="servicios-complementarios-section" className="py-20 md:py-28 lg:py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <ParallaxText speed={-0.12}>
            <ScrollFadeIn direction="left" delay={0}>
              <p className="text-calle-primary-50 text-xs uppercase tracking-[0.3em] mb-4 font-semibold font-body">
                Apoyo legal para decisiones empresariales
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn direction="left" delay={0.1}>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-calle-primary leading-[1.1] tracking-[-0.01em] mb-6">
                Servicios complementarios
              </h2>
            </ScrollFadeIn>
            <ScrollFadeIn direction="left" delay={0.15}>
              <div className="calle-underline mb-8"></div>
            </ScrollFadeIn>
            <ScrollFadeIn direction="left" delay={0.2}>
              <p className="text-gray-600 text-base leading-relaxed font-body">
                Además de la recuperación judicial de créditos, apoyamos a empresas en materias civiles, comerciales, societarias, contractuales y de representación judicial.
              </p>
            </ScrollFadeIn>
          </ParallaxText>

          <div className="space-y-4">
            {SERVICIOS_COMP.map((servicio, index) => (
              <ScrollFadeIn 
                key={servicio.id} 
                direction="right" 
                delay={0.1 + index * 0.08}
              >
                <ParallaxText speed={-0.02 * (index + 1)}>
                  <div 
                    data-testid={`servicio-comp-${servicio.id}`}
                    className="flex items-center gap-4 p-5 bg-gray-50 rounded-sm border border-gray-100 hover:border-calle-primary/30 hover:bg-gray-100 transition-all duration-500 group hover:-translate-x-2"
                  >
                    <div className="w-12 h-12 rounded-sm bg-white flex items-center justify-center shrink-0 group-hover:bg-calle-primary transition-all duration-500 border border-gray-200 group-hover:border-calle-primary group-hover:scale-110">
                      <servicio.icon className="h-5 w-5 text-calle-primary group-hover:text-white transition-colors duration-500" />
                    </div>
                    <span className="text-calle-primary font-medium font-body text-sm lg:text-base">
                      {servicio.title}
                    </span>
                  </div>
                </ParallaxText>
              </ScrollFadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
